// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"647":"ef381a6e","985":"032e5583"}[chunkId] + ".js";
};